import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.fadeTimer = setTimeout(() => {
      this.element.classList.add("animate__fadeOut")
    }, 1000)
    this.removeTimer = setTimeout(() => this.element.remove(), 4000)
  }

  disconnect() {
    clearTimeout(this.fadeTimer)
    clearTimeout(this.removeTimer)
  }
}
